import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useInvitationService } from "../../../hooks/useInvitationService";
import { activityQueryKeys } from "../constants";
import type { InviteMeta } from "../types";

/** Declines a workspace invite and invalidates activity queries. */
export function useDeclineInviteMutation(meta: InviteMeta) {
    const invitationService = useInvitationService();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () =>
            invitationService.respondToInvite({
                workspaceId: meta.workspaceId,
                token: meta.token,
                action: "decline"
            }),
        onSettled: () => queryClient.invalidateQueries({ queryKey: activityQueryKeys.all })
    });
}
